// Firebase configuration
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'

// Your web app's Firebase configuration
// You'll need to replace these with your actual Firebase project config
const firebaseConfig = {
  apiKey: "AIzaSyBWyTP_3Vzu0AAC5bGsR5ZhXJhDNtpkNBw",
  authDomain: "breakout-web.firebaseapp.com",
  projectId: "breakout-web",
  storageBucket: "breakout-web.firebasestorage.app",
  messagingSenderId: "1087992240257",
  appId: "1:1087992240257:web:bd292c59fe00487c8a1580"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firestore
export const db = getFirestore(app)

export default app